interface AuthHeader {
	'x-app-id'?: string;
	Authorization?: string;
	'x-request-context'?: string;
}

export const getAuthorizationHeaders = (isAppIdSkipped: boolean) => {
	const jwt = sessionStorage.getItem('jwt');
	const org = sessionStorage.getItem('org');
	const headers: AuthHeader = {};

	if (!isAppIdSkipped) {
		headers['x-app-id'] = 'SB';
	}

	if (jwt) {
		headers.Authorization = `Bearer ${jwt}`;
	}

	if (org) {
		headers['x-request-context'] = org;
	}

	return headers;
};
